module.exports = __webpack_public_path__ + "media/images/admin/magazines/icon_flower-a488456db68a1fe6c898754a2b692ef2.png";